import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, user, isLoading } = useUser();
  const location = useLocation();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-secondaryText">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the attempted location for redirect after login
    return <Navigate to="/account" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !user?.isAdmin) {
    return (
      <div className="max-w-md mx-auto py-12 text-center">
        <div className="card">
          <h1 className="text-2xl font-semibold text-primaryText mb-4">Access Denied</h1>
          <p className="text-secondaryText">You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  // User is authenticated and meets requirements
  return children;
}

export default ProtectedRoute;